import { useEffect } from "react";

// Injects the public Roket chat bubble (served by the backend) onto public
// pages. Uses the same script external sites embed, so behaviour is identical.
export const RoketPublicWidget = () => {
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base || window.__roketWidgetLoaded) return;
    const s = document.createElement("script");
    s.src = `${base}/api/public/roket-widget.js`;
    s.defer = true;
    s.dataset.roketWidget = "1";
    document.body.appendChild(s);
  }, []);
  return null;
};

export default RoketPublicWidget;
